import * as React from 'react';
import { TContactParam } from '@cian/newbuilding-chat-component';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../actions/authentication';
import { closeBuilderChat, openBuilderChat } from '../../actions/builderChat';
import { getUser } from '../../selectors/user';
import { TProduct } from '../../types/analytics';
import { TTypedThunkDispatch } from '../../types/thunk';
import { trackSendMessageClick, trackOpenChat } from '../../utils/builderChat';

type TUseBuilderChatParams = {
  gaLabel: string;
  product: TProduct;
  isPromoSnippet?: boolean;
};

export function useBuilderChat({ gaLabel, product, isPromoSnippet }: TUseBuilderChatParams) {
  const dispatch: TTypedThunkDispatch = useDispatch();
  const user = useSelector(getUser);

  const openChatWithTracking = React.useCallback(
    (chatContact: TContactParam) => {
      trackOpenChat({ label: gaLabel, product, isPromoSnippet });
      dispatch(
        openBuilderChat({
          chatContact,
          gaLabel,
        }),
      );
    },
    [dispatch, gaLabel, product, isPromoSnippet],
  );

  const openChat = React.useCallback(
    (chatContact: TContactParam) => {
      trackSendMessageClick({ label: gaLabel, product, isPromoSnippet });

      if (!user.isAuthenticated) {
        dispatch(
          requestAuthentication({
            onSuccess: () => () => openChatWithTracking(chatContact),
            onCloseNoAuth: closeBuilderChat,
          }),
        );

        return;
      }

      openChatWithTracking(chatContact);
    },
    [dispatch, openChatWithTracking, gaLabel, product, isPromoSnippet, user],
  );

  return { openChat };
}
